import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { CombinedConfig, WebappConfig, ShopifyProducts } from './app-config.types';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppInitService {

    private voyjaleasConfigUrl = environment.voyjaleasConfigUrl;

    private cfg$ = new ReplaySubject<CombinedConfig>(1);
    private _snapshot!: CombinedConfig;

    get config$() { return this.cfg$.asObservable(); }
    get snapshot(): CombinedConfig { return this._snapshot; }

    async load(app = 'webapp', env = (window as any).__ENV__ || 'pro'): Promise<void> {
      const VOYJALEAS_CONFIG_URL = this.voyjaleasConfigUrl+env;
      const bust = `v=${Date.now()}`;

      // Fetch both; don’t block the app if products file is missing
      const webappP = fetch(`${VOYJALEAS_CONFIG_URL}/${app}.json?${bust}`).then(r => r.json() as Promise<WebappConfig>);
      const productsP = fetch(`${VOYJALEAS_CONFIG_URL}/shopifyProducts.json?${bust}`)
        .then(r => r.ok ? r.json() as Promise<ShopifyProducts> : ({} as ShopifyProducts))
        .catch(() => ({} as ShopifyProducts));

      const [webapp, shopifyProducts] = await Promise.all([webappP, productsP]);

      this._snapshot = { ...webapp, shopifyProducts };
      this.cfg$.next(this._snapshot);

      // (Optional) expose for quick debugging in dev tools
      (window as any).__APP_CONFIG__ = this._snapshot;
    }

    /** Convenience helper */
    getProduct(variantId: string) {
      return this._snapshot?.shopifyProducts?.[variantId];
    }
    
}
